import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../src/assets/logo.webp";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import whatsappicon from "../src/assets/img/whatsappicon.gif";

function Register() {
    const [mobileNumber, setMobileNumber] = useState("");
    const [userName, setUserName] = useState("");
    const [otp, setOtp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [logoImage, setLogoImage] = useState(null);
    const [userTempId, setuserTempId] = useState(null);
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [resendTimer, setResendTimer] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem("isAdmin");
    const [countdown, setCountdown] = useState(0);

    useEffect(() => {
        if (isAdmin === "false") {
            navigate("/HomePage");
        }
    }, [isAdmin, navigate]);

    useEffect(() => {
        fetchSettings();
    }, []);


    // useEffect(() => {
    //     let timer;
    //     if (countdown > 0) {
    //         timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    //     }
    //     return () => clearTimeout(timer);
    // }, [countdown]);

    const fetchSettings = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL_NODE}settings`
            );

            if (!response.ok) {
                throw new Error("Failed to fetch settings");
            }

            const result = await response.json();
            setLogoImage(result[0]?.logo || result.logo || null);
            setWhatsappNumber(result?.whatsapp_no || "");
        } catch (error) {
            console.error("Error fetching settings:", error);
        }
    };
    const startResendTimer = () => {
        setResendTimer(10);
    };

    const handleSendOtp = async () => {
        // if (!mobileNumber || mobileNumber.length !== 10) {
        //     return Swal.fire("Error", "Please enter a valid 10-digit mobile number", "error");
        // }
        // if (!userName.trim()) {
        //     return Swal.fire("Error", "User Name is required", "error");
        // }

        // setLoading(true);

        try {

            // const res = await axios.post(`https://sara777chatapi.sindoor7.com/user/send-otp`, { mobileNumber, userName });
            const res = await axios.post(`https://api.Cash365days.in/user/send-otp`, { mobileNumber, userName });
            console.log("fddfdfdf", mobileNumber)
            if (res.data.status === 1) {
                setuserTempId(res.data.userTempId);
                setIsOtpSent(true);
                setCountdown(25);
                Swal.fire("Success", "OTP sent to your mobile number.", "success");
            }

            else {
                Swal.fire("Error", res.data.message || "Failed to send OTP", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Failed to send OTP", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleReSendOtp = async () => {
        // if (!mobileNumber || mobileNumber.length !== 10) {
        //     return Swal.fire("Error", "Please enter a valid 10-digit mobile number", "error");
        // }
        if (!userName.trim()) {
            return Swal.fire("Error", "User Name is required", "error");
        }

        setLoading(true);
        try {
            const res = await axios.post(`https://api.Cash365days.in/user/resend-otp`, { mobileNumber, userName });
            if (res.data.status === 1) {
                setuserTempId(res.data.userTempId);
                setIsOtpSent(true);
                startResendTimer();
                Swal.fire("Success", "OTP resent to your mobile number.", "success");
            } else {
                Swal.fire("Error", res.data.message || "Failed to resend OTP", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Failed to resend OTP", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleVerifyOtp = async () => {
        // alert("Please enter the OTP");
        if (!otp) {
            return Swal.fire("Error", "Please enter the OTP", "error");
        }

        setLoading(true);

        try {
            const res = await axios.post(`https://api.Cash365days.in/user/verify-otp`, { mobileNumber, otp, userTempId, userName, password });

            if (res.data.status === 1) {
                localStorage.setItem("userid", res.data.user.userId);
                localStorage.setItem("userToken", res.data.token);
                localStorage.setItem("isAdmin", res.data.user.isAdmin);

                Swal.fire("Success", "Registration successful!", "success").then(() => {
                    navigate("/HomePage");
                });
            } else {
                Swal.fire("Error", "Invalid OTP. Please try again.", "error");
            }
        } catch (error) {
            Swal.fire("Error", "An error occurred while verifying OTP.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleRegister = async () => {
        if (!userName.trim() || !password || !confirmPassword) {
            return Swal.fire("Error", "All fields are required", "error");
        }
        // if (!userName.trim() || !mobileNumber || !password || !confirmPassword) {
        //     return Swal.fire("Error", "All fields are required", "error");
        // }
        if (password !== confirmPassword) {
            return Swal.fire("Error", "Passwords do not match", "error");
        }
        setLoading(true);
        try {
            await axios.post("https://api.cash365days.in/user/register", { userName, password });
            Swal.fire("Success", "Registration Successful", "success").then(() => {
                navigate("/");
            });
        } catch (error) {
    Swal.fire(
            "Error",
            error?.response?.data?.message || "Registration Failed",
            "error"
        );        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="login_area py-5">
            <div className="container">
                <div className="row align-items-center g-4">
                    <div className="col-xl-6 offset-xl-3">
                        <div className="hfive_card p-6 p-sm-9 rounded-3">
                            <div className="d-flex justify-content-center">
                                {whatsappNumber && (
                                    <a href={`https://wa.me/+91${whatsappNumber}`} target="_blank" rel="noopener noreferrer">
                                        <div className="whatsappicon">
                                            <img className="whatsapp-img" src={whatsappicon} alt="WhatsApp" />
                                        </div>
                                    </a>
                                )}
                            </div>

                            <div className="text-center">
                                <img className="img-fluid logo-color mt-3" src={logoImage ? `https://api.Cash365days.in/uploads/${logoImage}` : logo} alt="Logo" width={200} />
                            </div>

                            <div className="login-content">
                                <h2 className="h4 fw-bold">Register</h2>
                                <p>Sign up to create your account</p>

                                <form>
                                    <div className="d-flex flex-column gap-4">

                                        <div>
                                            <label className="h6  text-opacity-75 mb-3">
                                                User Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                                                placeholder="Enter User Name"
                                                value={userName}
                                                onChange={(e) => setUserName(e.target.value)}
                                            />
                                        </div>

                                        {/* <div>
                                            <label className="h6  text-opacity-75 mb-3">
                                                Mobile Number
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                                                placeholder="Enter Mobile Number"
                                                value={mobileNumber}
                                                maxLength={10}
                                                onChange={(e) => setMobileNumber(e.target.value)}
                                            />
                                        </div> */}

                                        <div className="position-relative">
                                            <label>Set Password</label>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25 py-2 rounded-3"
                                                placeholder="Enter Password"
                                                value={password}
                                                maxLength={8}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <span
                                                className="position-absolute eye end-0 translate-middle-y pe-3"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>

                                        <div className="position-relative mt-3">
                                            <label>Confirm Password</label>
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25 py-2 rounded-3"
                                                placeholder="Confirm Password"
                                                value={confirmPassword}
                                                maxLength={8}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <span
                                                className="position-absolute eye end-0 translate-middle-y pe-3"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            >
                                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>

                                        {/* {isOtpSent && (
                                            <div>
                                                <label>Enter OTP</label>
                                                <input type="text"
                                                    className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                                                    placeholder="Enter OTP"
                                                    value={otp}
                                                    maxLength={6}
                                                    onChange={(e) => setOtp(e.target.value)} />
                                            </div>
                                        )} */}
                                    </div>

                                    {/* {!isOtpSent ? (
                                        <button
                                            type="button"
                                            className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                                            onClick={handleSendOtp}
                                            disabled={loading}
                                        >
                                            {loading ? "Sending OTP..." : "Send OTP"}
                                        </button>
                                    ) : countdown > 0 ? (
                                        <button
                                            type="button"
                                            className="btn px-6 bg-secondary text-white rounded-3 border-0 mt-2 w-100"
                                            disabled
                                        >
                                            Resend OTP in {countdown}s
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                                            onClick={handleSendOtp}
                                            disabled={loading}
                                        >
                                            {loading ? "Sending OTP..." : "Resend OTP"}
                                        </button>
                                    )} */}


                                    {/* Show "Verify OTP" button when OTP is sent */}
                                    {/* {isOtpSent && (
                                        <button
                                            type="button"
                                            className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                                            onClick={handleVerifyOtp}
                                            disabled={loading}
                                        >
                                            {loading ? "Verifying OTP..." : "Verify OTP"}
                                        </button>
                                    )} */}

                                    <button
                                        type="button"
                                        className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                                        onClick={handleRegister}
                                        disabled={loading}
                                    >
                                        {loading ? "Registering..." : "Register"}
                                    </button>
                                    <p className="mt-2 text-center">
                                        Already have an account? <Link to="/">Login</Link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Register;
